import { Modal } from "antd";
import { TipoTenantEnum } from "core/resources/enums/tenant";
import history from "infra/helpers/history";
import { useState } from "react";
import SelectBaseAntd from "ui/components/Input/SelectBaseAntd";

function ModalTipo({ onSave }: { onSave: (v: TipoTenantEnum) => void }) {
  const [openModal, setOpenModal] = useState(true);
  const [value, setValue] = useState<TipoTenantEnum>();

  return (
    <Modal
      title="Tipo do cliente"
      okText="Continuar"
      visible={openModal}
      onOk={() => {
        if (value) {
          onSave(value);

          setTimeout(() => {
            setOpenModal(false);
          }, 500);
        }
      }}
      onCancel={() => {
        history.push(`/clientes`);
      }}
    >
      <SelectBaseAntd
        options={[
          {
            label: "Condomínio",
            value: TipoTenantEnum.Condominio,
          },
          {
            label: "Administradora",
            value: TipoTenantEnum.Administradora,
          },
          {
            label: "Construtora",
            value: TipoTenantEnum.Construtora,
          },
          {
            label: "Imobiliária",
            value: TipoTenantEnum.Imobiliaria,
          },
          {
            label: "Incorporadora",
            value: TipoTenantEnum.Incorporadora,
          },
          {
            label: "Empresa Comum",
            value: TipoTenantEnum.EmpresaComum,
          },
        ]}
        value={value}
        onChange={(v) => setValue(v)}
      />
    </Modal>
  );
}

export default ModalTipo;
